import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link as RouterLink } from 'react-router-dom';
import useScreen from 'hooks/useScreen';
import Avatar from 'sharedComponents/Avatar';
import LoanOfficerPresenter from 'presenters/administrator/LoanOfficerPresenter';

import { Typography, Link } from '@material-ui/core';
import { appRoutes } from 'routes';

import useStyles from './useStyles';

const LoanOfficerCard = props => {
  const { loanOfficer } = props;
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { t } = useTranslation();

  const id = LoanOfficerPresenter.loanOfficerId(loanOfficer);

  return (
    <Link to={appRoutes.adminLoanOfficerPath(id)} component={RouterLink} className={classes.item}>
      <Avatar size="s" imageUrl={LoanOfficerPresenter.profileImageUrl(loanOfficer)} />
      <Typography noWrap className={classes.loanOfficerName} variant="h3">
        {LoanOfficerPresenter.loanOfficerName(loanOfficer)}
      </Typography>
      {isDesktop && (
        <div className={classes.infoBox}>
          <div className={classes.companyInfo}>
            <div className={classes.companyInfoItem}>
              <Typography className={classes.companyInfoItemLabel} variant="subtitle1" color="secondary">
                {t('components.AdminDashboard.LoanOfficersList.LoanOfficerCard.company')}
              </Typography>
              <Typography noWrap variant="subtitle1" color="secondary">
                {LoanOfficerPresenter.company(loanOfficer)}
              </Typography>
            </div>
            <div className={classes.companyInfoItem}>
              <Typography className={classes.companyInfoItemLabel} variant="subtitle1" color="secondary">
                {t('components.AdminDashboard.LoanOfficersList.LoanOfficerCard.companyNmls')}
              </Typography>
              <Typography noWrap variant="subtitle1" color="secondary">
                {LoanOfficerPresenter.mortgageCompanyNmls(loanOfficer)}
              </Typography>
            </div>
          </div>
          <div className={classes.loanOfficerInfo}>
            <Typography className={classes.loanOfficerInfoLabel} variant="subtitle1" color="secondary">
              {t('components.AdminDashboard.LoanOfficersList.LoanOfficerCard.nmls')}
            </Typography>
            <Typography noWrap variant="h3" color="secondary">
              {LoanOfficerPresenter.nmls(loanOfficer)}
            </Typography>
          </div>
          <div className={classes.loanOfficerEmail}>
            <Typography className={classes.loanOfficerInfoLabel} variant="subtitle1" color="secondary">
              {t('components.AdminDashboard.LoanOfficersList.LoanOfficerCard.email')}
            </Typography>
            <Typography noWrap variant="h3" color="secondary">
              {LoanOfficerPresenter.email(loanOfficer)}
            </Typography>
          </div>
        </div>
      )}
    </Link>
  );
};

LoanOfficerCard.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
};

export default LoanOfficerCard;



// WEBPACK FOOTER //
// ./src/components/AdminDashboard/components/LoanOfficersList/components/LoanOfficerCard/LoanOfficerCard.js